import React from 'react';

const FloatingLabelTextarea = ({
  label,
  id,
  name,
  value,
  onChange,
  required = false,
  rows = 4,
  className = '',
}) => {
  return (
    <div className={`relative w-full ${className}`}>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        rows={rows}
        className="peer h-20 w-full border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
      <label
        htmlFor={id}
        className="absolute left-3 -top-3.5 bg-white px-1 text-sm text-gray-500 transition-all 
          peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 
          peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-blue-500"
      >
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelTextarea;
